import { Link } from 'react-router-dom';

const trustPoints = [
  { icon: 'ri-roadster-line', text: 'Furgoneta propia equipada — desplazamiento rápido' },
  { icon: 'ri-timer-line', text: 'Respuesta en 24/48 horas en toda Málaga' },
  { icon: 'ri-price-tag-3-line', text: 'Presupuesto gratis sin compromiso' },
  { icon: 'ri-shield-check-line', text: 'Garantía de 2 años en reparaciones e instalaciones' },
  { icon: 'ri-map-pin-line', text: 'Málaga capital y provincia — costa del Sol' },
  { icon: 'ri-star-line', text: 'Más de 500 clientes satisfechos' },
];

export default function ReassuranceSection() {
  return (
    <section className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-8 md:py-12">
      <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10 rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden p-5 md:p-8">
        {/* Image — vehicle */}
        <div className="w-full md:w-2/5 shrink-0">
          <div className="rounded-xl overflow-hidden aspect-[4/3] md:aspect-[16/10]">
            <img
              src="/images/vehiculo.webp"
              alt="Furgoneta profesional de Toldos Málaga — Servicio de reparación e instalación de toldos en Málaga"
              title="Toldos Málaga — Equipo de tolderos con vehículo propio equipado"
              className="w-full h-full object-cover object-center"
              loading="lazy"
            />
          </div>
        </div>

        {/* Text */}
        <div className="flex-1">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
            Toldos Málaga — <span className="text-primary-500">Servicio profesional</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
            Tolderos con más de 15 años de experiencia reparando e instalando toldos en Málaga. Furgoneta propia equipada, desplazamiento rápido a cualquier punto de la provincia. No somos intermediarios: medimos, reparamos e instalamos nosotros mismos.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {trustPoints.map((point) => (
              <div key={point.text} className="flex items-center gap-2.5">
                <div className="w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${point.icon} text-primary-600 text-xs`}></i>
                </div>
                <span className="text-sm text-foreground-700 leading-tight">{point.text}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap items-center gap-3 mt-6">
            <Link
              to="/presupuesto"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              <span>Presupuesto Gratis</span>
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
            <a
              href="tel:+34951120770"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-background-200 text-foreground-700 text-sm font-semibold rounded-full hover:bg-background-200 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-phone-line text-primary-500"></i>
              <span>951 12 07 70</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}